'use strict';

module.exports = {
    HTTP_URL: 'http://api.mapbox.com',
    HTTPS_URL: 'https://api.mapbox.com',
    FORCE_HTTPS: true,
    REQUIRE_ACCESS_TOKEN: true,
    TEMPLATE_STYLES: {
        'mapbox.dark': 'mapbox/dark-v10',
        'mapbox.light': 'mapbox/light-v10',
        'mapbox.osm-bright': 'mapbox/bright-v9',
        'mapbox.outdoors': 'mapbox/outdoors-v11', 
        'mapbox.satellite': 'mapbox/satellite-v9',
        'mapbox.streets': 'mapbox/streets-v11', 
        'mapbox.streets-basic': 'mapbox/basic-v9',
        'mapbox.streets-satellite': 'mapbox/satellite-streets-v11'
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/config.js
// module id = 81
// module chunks = 1